import React, { useCallback, useEffect, useMemo, useState } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import {
  RESET_EHR_DOCUMENTS,
  RESET_DOCUMENT_LIBRARY_ROWS,
  REFRESH_USER_DOCUMENT_GRID,
  SET_ATTACH_DOCUMENT_COMPONENT_MODE,
  SET_DOCUMENT_DATA_TO_SAVE,
  SET_DOCUMENT_POPUP_MODE,
  SET_EPIC_NOTES_SELECTED_ROWS,
  SET_SELECTED_ROW_DATA,
  SET_SINGLE_DOCUMENT_DATA,
  TOGGLE_EDIT_DOCUMENT_POPUP,
  formatDocumentToSaveObjectForUpdate,
  initialDocumentDataToSave,
} from "./reducers/document-management-reducer";
import { useDispatch, useSelector } from "react-redux";
import { EDIT_DOCUMENT } from "./services/edit-document";
import { actions as asyncActions, callOperation } from "async-ops";
import { HIDE_LOADER, SHOW_LOADER } from "../mdae-common-reducer";
import {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import WaitTimeMessageModal from "./wait-time-message-modal";
import { GET_DOCUMENTS } from "./services/get-documents";
import { bindActionCreators } from "redux";
import { initiateOCRPolling } from "../case-search/use-ocr-polling";
import {
  SET_S3_OBJECT_NAME,
} from "../case-search/reducers/case-search-reducer";
import mdaeNotify from "../../common_components/common_widgets/toast/notify";
import dxFileUploader from "devextreme/ui/file_uploader";
import dxDataGrid from "devextreme/ui/data_grid";
import { first } from "lodash";
import MdaeTabPanel from "../common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import DocumentManagement, { USER_ACTION_MODE } from "./component";
import { ATTACH_DOCUMENT } from "./services/attach-documents";
import { FG_EXTERNAL_USER_TASK_EDITING, hasAnyFeatureGroupAccess } from "../user-permissions-helper";
import EhrDocumentsComponent, { importEhrDocumentation } from "./ehr-documentation-component";
import DocumentLibraryGrid from "./document-library-grid";
import { ADD_ROUND_DOCUMENTS } from "../../pages/external-audit-setup/process-template/reducer/process-template-reducer";
import { SET_DOCUMENT_LIBRARY_SELECTED_ROWS } from "./reducers/document-management-reducer";
import { SAVE_UPLOADED_USER_DOCUMENTS } from "./services/save-uploaded-document";
import { EDIT_OR_ATTACH_COMPONENT_MODES, EditOrAttachDocument, PAYER_AUDIT_LEVEL_OPTIONS } from "./edit-or-attach-document";
import { getFileExtension } from "./common-functions";
import { INSERT_DOCUMENT_EVENT } from "./services/insert-document-event";
import { logDocumentLifecycleEvent } from "./services/log-document-lifecycle-event";
const formatFileSize = (bytes: number): string => {
  if (!bytes) return "";
  if (bytes >= 1073741824) return `${(bytes / 1073741824).toFixed(2)} GB`;
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(2)} MB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${bytes} Bytes`;
};

// Sequential counter for pending (not-yet-saved) document association IDs.
// Negative values so they never collide with real positive DB IDs.
let _pendingDocIdSeq = 0;
export const nextPendingId = () => --_pendingDocIdSeq;

export const DOCUMENT_POPUP_MODE = {
  UPLOAD: "UPLOAD",
  EDIT: "EDIT",
  OCR_UPLOAD: "OCR_UPLOAD",
};
export const documentValidationMessage =
  "This document contains invalid special characters. Please rename the document by removing the special characters or using one of the following: & $ @ = ! - _ . ) ( '";
export const documentValidationGroup = "documentValidationGroup";
export const toggleEditDocumentPopupVisible = (
  dispatch,
  isVisible,
  dataSourceStoreId,
  title = "",
  mode = "",
  data: any = { ...initialDocumentDataToSave },
  attachDocumentComponentCurrentMode = EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER
) => {
  dispatch({
    type: SET_DOCUMENT_POPUP_MODE,
    data: {
      documentPopupMode: mode,
    },
  });
  dispatch({
    type: SET_ATTACH_DOCUMENT_COMPONENT_MODE,
    data: {
      attachDocumentComponentCurrentMode
    },
  });
  dispatch({
    type: SET_EPIC_NOTES_SELECTED_ROWS,
    data: { selectedEhrDocuments: [] },
  });
  dispatch({
    type: RESET_EHR_DOCUMENTS,
  });
  dispatch({
    type: RESET_DOCUMENT_LIBRARY_ROWS,
  });
  dispatch({
    type: TOGGLE_EDIT_DOCUMENT_POPUP,
    data: {
      ...data,
      isEditDocumentPopupVisible: isVisible,
      editDocumentPopupTitle: title,
      editDocumentPopupMode: mode,
      attachedLevelName: data.attachedLevelName,
      attachedLevelId: data.attachedLevelId,
      activePopupStoreId: dataSourceStoreId,
    },
  });
  if (
    [DOCUMENT_POPUP_MODE.EDIT, DOCUMENT_POPUP_MODE.OCR_UPLOAD].includes(mode)
  ) {
    dispatch({
      type: SET_DOCUMENT_DATA_TO_SAVE,
      data: {
        documentDataToSave: [
          {
            ...data,
            documentName: data.documentName,
            documentCategoryId: data.documentCategoryId,
            saveToDocumentManagement: data.saveToDocumentManagement,
            attachedLevelId: data.attachedLevelId,
            attachedLevelName: data.attachedLevelName,
          },
        ],
        uniqueId: dataSourceStoreId
      },
    });
  } else {
    dispatch({
      type: SET_DOCUMENT_DATA_TO_SAVE,
      data: {
        documentDataToSave: [],
        uniqueId: dataSourceStoreId + EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER
      },
    });
    dispatch({
      type: SET_DOCUMENT_DATA_TO_SAVE,
      data: {
        documentDataToSave: [],
        uniqueId: dataSourceStoreId + EDIT_OR_ATTACH_COMPONENT_MODES.EHR
      },
    });
    dispatch({
      type: SET_DOCUMENT_DATA_TO_SAVE,
      data: {
        documentDataToSave: [],
        uniqueId: dataSourceStoreId + EDIT_OR_ATTACH_COMPONENT_MODES.DOCUMENT_LIBRARY
      },
    });
  }
};

export const documentFieldValueChangeEvent = (dispatch, name, value, uniqueId) => {
  dispatch({
    type: SET_SINGLE_DOCUMENT_DATA,
    data: {
      [name]: value,
      uniqueId: uniqueId
    },
  });
};

export function isPopupCloseSafe(state: any, dataSourceStoreId): any {
  return (
    state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD ||
    state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.EDIT ||
    (state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.UPLOAD &&
      state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]?.every(
        (x) =>
          x.uploadProgress === 100 ||
          x.uploadProgress === -1 ||
          x.uploadProgress === null
      ))
  );
}

export interface IEditDocumentPopup {
  doNotRefreshDataGrid?: boolean;
  taskAttachmentLevel?: string;
  parentAttachmentLevelName?: string;
  parentAttachmentLevelId?: string;
  uniqueId?: string;
  hideEhrTab?: boolean;
  showDocumentLibrary?: boolean;
}
const EditDocumentPopup: React.FC<IEditDocumentPopup> = (props) => {
  let storeIdSuffix = "";
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const attachDocumentComponentCurrentMode = useSelector(
    (state) => state["documentManagementReducer"].attachDocumentComponentCurrentMode ?? ""
  );
  const documentUploaderInstance: dxFileUploader = dxFileUploader.getInstance(
    document.getElementById("btnFileUploader_" + attachDocumentComponentCurrentMode)
  ) as dxFileUploader;
  const documentDataGridInstance = dxDataGrid.getInstance(
    document.getElementById("grdDocumentUpload_" + attachDocumentComponentCurrentMode)
  ) as dxDataGrid;

  const editDocumentPopupTitle = useSelector(
    (state) => state["documentManagementReducer"].editDocumentPopupTitle
  );
  
  const isPopupModeUploadToOCR = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
      DOCUMENT_POPUP_MODE.OCR_UPLOAD
  );
  const editDocumentPopupMode = useSelector(
    (state) => state["documentManagementReducer"].editDocumentPopupMode
  );

  if(editDocumentPopupMode !== DOCUMENT_POPUP_MODE.EDIT && editDocumentPopupMode !== DOCUMENT_POPUP_MODE.OCR_UPLOAD){
    storeIdSuffix = attachDocumentComponentCurrentMode;
  }
  const activePopupStoreId = useSelector(
    (state: any) => state["documentManagementReducer"].activePopupStoreId
  );
  const effectiveBaseId = activePopupStoreId ?? props.uniqueId ?? '';
  const dataSourceStoreId = effectiveBaseId + storeIdSuffix;

  const isDocumentPopupSafeToClose: boolean = useSelector((state: any) => {
    return isPopupCloseSafe(state, dataSourceStoreId);
  });
  const documentDataToSave: Array<typeof initialDocumentDataToSave> = useSelector(
    (state: any) => state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]
  );
  const attachedLevelId = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelId
  );
  const attachedLevelName = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelName
  );
  const includeNonAuditLevelDocumentInd = useSelector(
    (state) =>
      state["documentManagementReducer"].includeNonAuditLevelDocumentInd
  );
  const eaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"]?.auditPropertiesData?.eaAuditId
  );
  const documentAttachmentLevelEnums = useSelector(
    (state) => state["documentManagementReducer"].documentAttachmentLevels
  );
  const clientId = useSelector(
    (state: any) => state["mdaeNavigationBarReducer"]?.currentUser?.clientId
  );
  const isEditDocumentPopupVisible = useSelector(
    (state: any) => state["documentManagementReducer"].isEditDocumentPopupVisible
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser
  );
  const hasExtrnlUserTaskEditFg = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_EXTERNAL_USER_TASK_EDITING],
        currentUser
      ),
    [currentUser]
  );

  const isEhrInboundAPIEnabled = useSelector(
    (state) => state["documentManagementReducer"].isEhrInboundAPIEnabled
  );

  const selectedRowsData = useSelector(
    (state: any) => state["documentManagementReducer"].selectedRowsData
  );

  const documentPopupMode = useSelector(
    (state: any) => state["documentManagementReducer"].documentPopupMode
  );
  const isModeTaskUpload =
    attachedLevelName === "TS" &&
    documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD;

  const isModeEACaseUpload =
    attachedLevelName === "EAC" &&
    documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD;

  const isModeEAAuditUpload =
    attachedLevelName === "EA" &&
    documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD;

  const setSelectedRowsData = useCallback((selectedRowsData) => {
    dispatch({ type: SET_SELECTED_ROW_DATA, data: { selectedRowsData } });
  }, []);

  const onLibrarySelectionChanged = useCallback((rows) => {
    dispatch({ type: SET_DOCUMENT_LIBRARY_SELECTED_ROWS, data: { selectedDocumentLibraryRows: rows } });
  }, [dispatch]);

  const [libraryDocumentList, setLibraryDocumentList] = useState<any[]>([]);
  useEffect(() => {
    if (!isEditDocumentPopupVisible || (!isModeEACaseUpload && !isModeTaskUpload && !isModeEAAuditUpload)) return;
    callOperation(GET_DOCUMENTS, { attachedLevelId: 2, attachedLevelName: "DL", isManagerView: true })
      .then((response: any) => {
        const raw: any[] = response?.data?.documentList ?? response?.documentList ?? [];
        setLibraryDocumentList(
          raw.map((doc: any) => ({
            ...doc,
            fileType: doc.originalFileName?.split(".").pop().toLowerCase() ?? "",
            fileSizeDisplayName: formatFileSize(doc.fileSize),
            attachedLevelName: null,
          }))
        );
      });
  }, [isEditDocumentPopupVisible, isModeEACaseUpload, isModeTaskUpload, isModeEAAuditUpload]);

  const uploadDocumentCount = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]?.length ?? 0
  );
  const selectedEhrDocuments: any[] = useSelector(
    (state: any) =>
      state["documentManagementReducer"].ehrConnectorData.selectedEhrDocuments
  );
  const selectedDocumentLibraryRows: any[] = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentLibraryConnectorData?.selectedDocumentLibraryRows ?? []
  );
  const totalTemplateDocumentCount: number = useSelector(
    (state: any) =>
      (state["processTemplateReducer"]?.processTemplateRoundList ?? []).reduce(
        (sum, r) => sum + (r.processTemplateRoundDocumentList?.length ?? 0),
        0
      )
  );
  const selctedAttachItemCount =
    (selectedRowsData?.length ?? 0) + uploadDocumentCount;

  const areAllDocumentsUploaded: boolean = useSelector(
    (state: any) =>
      state.documentManagementReducer.editDocumentPopupMode ===
        DOCUMENT_POPUP_MODE.UPLOAD &&
      state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]?.length > 0 &&
      state["documentManagementReducer"].documentDataToSaveStore[dataSourceStoreId]?.every(
        (x) => x.uploadProgress === 100
      ) &&
      (selectedRowsData?.length ?? 0) === 0
  );
  const disableMyComputerSelection =
    isPopupModeUploadToOCR && (selectedRowsData?.length ?? 0) > 0;
  const disableGridSelection =
    isPopupModeUploadToOCR &&
    (documentDataToSave?.length ?? 0) > 0 &&
    first(documentDataToSave).selectedFile != null;

  useEffect(() => {
    if (areAllDocumentsUploaded)
      toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
  }, [areAllDocumentsUploaded, editDocumentPopupMode]);

  useEffect(() => {
    if(isEditDocumentPopupVisible){
      setSelectedRowsData([]);
    }
  }, [isEditDocumentPopupVisible])

  const refreshDocumentList = useCallback(() => {
    asyncAction.asyncOperationStart(GET_DOCUMENTS, {
      attachedLevelId: attachedLevelId,
      attachedLevelName: attachedLevelName,
      showForCoderReviewInd: includeNonAuditLevelDocumentInd,
      isManagerView: attachedLevelName === "DL",
      uniqueId: effectiveBaseId,
    });
  }, [attachedLevelId, attachedLevelName, includeNonAuditLevelDocumentInd, effectiveBaseId]);

  const attachDocuments = useCallback(() => {
    dispatch({ type: SHOW_LOADER });
    const documents: any[] = selectedRowsData.map((document) => {
      return {
        attachedLevelId: attachedLevelId,
        attachedLevelName: attachedLevelName,
        documentId: document.documentId,
        documentName: document.documentName,
        originalFileName: document.originalFileName,
        s3ObjectName: document.s3ObjectName,
        tags: {
          clientId: clientId.toString(),
        },
        ocrMetricTrackingData: {
          pageCount: 0,
          eaAuditId: 0,
        },
      };
    });

    let documentAtachPromises = [];
    if (documents?.length > 0) {
      documents.forEach((document) => {
        if (isPopupModeUploadToOCR) {
          document.sendDocumentToOCR = true;
          document.attachedLevelName =
            documentAttachmentLevelEnums.externalAuditOCR;
          document.ocrMetricTrackingData = {
            pageCount: 0,
            eaAuditId,
          };
        }
        const documentAttachPromise = callOperation(
          ATTACH_DOCUMENT,
          document
        ).then((response) => {
          mdaeNotify({
            message: document.documentName + " attached successfully!",
            messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
          });
          return response;
        });
        documentAtachPromises.push(documentAttachPromise);
      });
    }

    return Promise.all(documentAtachPromises).then((responses) => {
      dispatch({ type: HIDE_LOADER });
      if (!props.doNotRefreshDataGrid) refreshDocumentList();
      if (isPopupModeUploadToOCR) {
        const attachResponse = first(responses);
        dispatch({
          type: SET_S3_OBJECT_NAME,
          data: attachResponse.data,
        });
        initiateOCRPolling(dispatch, asyncAction, {
          s3ObjectName: attachResponse.data,
        });
      }
      setSelectedRowsData([]);
    });
  }, [
    attachedLevelName,
    attachedLevelId,
    selectedRowsData,
    isDocumentPopupSafeToClose,
    documentAttachmentLevelEnums,
    isPopupModeUploadToOCR,
    documentDataToSave,
  ]);
  const uploadDocuments = useCallback(() => {
    if (documentPopupMode === DOCUMENT_POPUP_MODE.EDIT) {
      if (first(documentDataToSave).documentName) {
        callOperation(
            EDIT_DOCUMENT,
            formatDocumentToSaveObjectForUpdate(first(documentDataToSave))
          ).then((response)=>{
            if(!response.isEdited){
              mdaeNotify({
                message:response.error,
                messageType: NOTIFY_MESSAGE_TYPE.ERROR,
              })
            } else {
              dispatch({ type: REFRESH_USER_DOCUMENT_GRID });
            }
            toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
          })       
        }
    } else documentUploaderInstance.upload();
  }, [
    documentUploaderInstance,
    documentPopupMode,
    documentDataToSave,
    documentDataGridInstance,
  ]);

  const onDocumentPopupSaveButtonClick = useCallback(
    (params) => {
      if (
        attachDocumentComponentCurrentMode ===
        EDIT_OR_ATTACH_COMPONENT_MODES.DOCUMENT_LIBRARY
      ) {
        if (!selectedDocumentLibraryRows?.length) {
          mdaeNotify({
            message: "Please select at least one document from the library.",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
          return;
        }
        if (isModeTaskUpload || isModeEAAuditUpload || (isModeEACaseUpload && !props.hideEhrTab)) {
          dispatch({ type: SHOW_LOADER });
          const attachPromises = selectedDocumentLibraryRows.map((doc) =>
            callOperation(ATTACH_DOCUMENT, {
              attachedLevelId: attachedLevelId,
              attachedLevelName: attachedLevelName,
              documentId: doc.documentId,
              documentName: doc.documentName,
              originalFileName: doc.originalFileName,
              s3ObjectName: doc.s3ObjectName,
              documentCategoryId: doc.documentCategoryId,
              source: "Document Library",
              tags: { clientId: clientId.toString() },
              ocrMetricTrackingData: { pageCount: 0, eaAuditId: 0 },
              applicationName :'mdaudit'
            })
          );
          Promise.all(attachPromises)
            .then(() => {
              dispatch({ type: HIDE_LOADER });
              dispatch({ type: SET_DOCUMENT_LIBRARY_SELECTED_ROWS, data: { selectedDocumentLibraryRows: [] } });
              refreshDocumentList();
              toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
              mdaeNotify({ message: "Documents attached successfully.", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS });
            })
            .catch(() => {
              dispatch({ type: HIDE_LOADER });
              mdaeNotify({ message: "Failed to attach documents.", messageType: NOTIFY_MESSAGE_TYPE.ERROR });
            });
          return;
        }
        const missingLibraryLevel = props.hideEhrTab && selectedDocumentLibraryRows.some((doc) => !doc.attachedLevelName);
        if (missingLibraryLevel) {
          mdaeNotify({
            message: "Please select a level for all selected documents.",
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
          return;
        }
        const MAX_DOCS = 20;
        if (totalTemplateDocumentCount + selectedDocumentLibraryRows.length > MAX_DOCS) {
          mdaeNotify({
            message: `A process template can have a maximum of ${MAX_DOCS} documents. This template currently has ${totalTemplateDocumentCount}.`,
            messageType: NOTIFY_MESSAGE_TYPE.ERROR,
          });
          return;
        }
        selectedDocumentLibraryRows.forEach((doc) => {
          dispatch({
            type: ADD_ROUND_DOCUMENTS,
            data: {
              eaProcessTemplateRoundId: attachedLevelId,
              pendingDocument: {
                eaProcessTemplateRoundDocumentAssociationId: nextPendingId(),
                documentId: doc.documentId,
                documentName: doc.documentName,
                originalFileName: doc.originalFileName,
                fileType: doc.fileType ?? doc.originalFileName?.split('.').pop() ?? '',
                fileSize: doc.fileSize,
                fileSizeDisplayName: doc.fileSizeDisplayName ?? '',
                documentCategoryId: doc.documentCategoryId,
                documentCategoryName: doc.documentCategoryName,
                attachedLevelName: doc.attachedLevelName,
                attachedLevelDisplayName: PAYER_AUDIT_LEVEL_OPTIONS.find((l) => l.code === doc.attachedLevelName)?.displayName ?? '',
                s3ObjectName: doc.s3ObjectName,
                createdBy: currentUser?.userName ?? '',
                createDate: new Date().toISOString(),
              },
            },
          });
        });
        dispatch({
          type: SET_DOCUMENT_LIBRARY_SELECTED_ROWS,
          data: { selectedDocumentLibraryRows: [] },
        });
        toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
        mdaeNotify({
          message: "Documents attached to round successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
        return;
      }
      if (
        attachDocumentComponentCurrentMode ===
        EDIT_OR_ATTACH_COMPONENT_MODES.EHR
      ) {
        if (documentDataToSave?.length > 0) {
          const documentSavePromises = [];
          dispatch({ type: SHOW_LOADER });
          documentDataToSave.forEach((documentDataItem) => {
            const documentDataItemToSave = {
              ...documentDataItem,
              attachedLevelId: attachedLevelId,
              attachedLevelName: "EAC",
              isDocumentConverted: ["html", "pdf", "xml", "rtf"].includes(
                getFileExtension(documentDataItem?.originalFileName),
              ) ? false : null,
              source: "EHR"
            };
            documentSavePromises.push(
              callOperation(
                SAVE_UPLOADED_USER_DOCUMENTS,
                documentDataItemToSave,
              ),
            );
          });

          Promise.all(documentSavePromises).then((responses: any[]) => {
            dispatch({ type: HIDE_LOADER });
            toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
            refreshDocumentList();
            responses.forEach((responseItem) => {
              logDocumentLifecycleEvent(responseItem.documentId, "DOCUMENT_UPLOADED", "upload", attachedLevelName, attachedLevelId);
            });
          }).catch((error) => {
            dispatch({ type: HIDE_LOADER });
            mdaeNotify({
              message: "Failed to save or attach documents.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          });
        } else {
          if(selectedEhrDocuments?.length > 0){
            dispatch(importEhrDocumentation(dataSourceStoreId));
          }else{
             mdaeNotify({
              message: "Please Select at least one documentation to import.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          }
        }
        return;
      }
      let saveChangesPromise = Promise.resolve();
      if (documentDataGridInstance?.hasEditData()) {
        saveChangesPromise = documentDataGridInstance?.saveEditData();
      }
      saveChangesPromise.then(() => {
        if (!params.validationGroup) return;
        let result = null;
        if (params.validationGroup) result = params.validationGroup.validate();
        if (result && result.isValid) {
          const currentDocData = documentDataGridInstance?.getDataSource()?.items() ?? documentDataToSave ?? [];
          if (props.hideEhrTab && currentDocData.some((doc) => !doc.attachedLevelName)) {
            mdaeNotify({
              message: "Please select a level for all selected documents.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
            return;
          }
          let documentSavePromise = Promise.resolve();
          if (isModeTaskUpload || isPopupModeUploadToOCR) {
            if(uploadDocumentCount > 0 && first(documentDataToSave)?.selectedFile != null)
              uploadDocuments();
            if ((selectedRowsData?.length ?? 0) > 0)
              documentSavePromise = attachDocuments();
          } else {
            uploadDocuments();
          }
          documentSavePromise.then(() => {
            if (
              uploadDocumentCount === 0 ||
              first(documentDataToSave)?.selectedFile == null
            )
              toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
          })
          .catch((error) => {
            dispatch({ type: HIDE_LOADER });
            mdaeNotify({
              message: "Failed to save or attach documents.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          });
        } else{
          result.brokenRules[0]?.validator?.focus();
          if (selctedAttachItemCount > 0)
            mdaeNotify({
              message: "Please remove selected unsupported/invalid file(s)",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          else if (selctedAttachItemCount === 0)
            mdaeNotify({
              message: "Please Select at least one file",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
        }
      });
    },
    [
      isModeTaskUpload,
      attachDocuments,
      uploadDocuments,
      areAllDocumentsUploaded,
      isPopupModeUploadToOCR,
      attachDocumentComponentCurrentMode,
      documentDataToSave,
      attachedLevelId,
      dataSourceStoreId,
      documentDataGridInstance,
      uploadDocumentCount,
      selctedAttachItemCount,
      selectedEhrDocuments,
      selectedDocumentLibraryRows,
      totalTemplateDocumentCount
    ]
  );

  const getSamplePopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          isDocumentPopupSafeToClose &&
            toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
        }}
      >
        {editDocumentPopupTitle}
      </MdaePopupTitle>
    );
  };
  const documentManagementPopupUpdaterConfig = useMemo(
    () => [
      {
        actionType: TOGGLE_EDIT_DOCUMENT_POPUP,
        reducerName: "documentManagementReducer",
        widgetOptionBindings: {
          visible: "isEditDocumentPopupVisible",
          mdaePopupTitle: "editDocumentPopupTitle",
        },
      },
    ],
    [],
  );

  const onTabPanelSelectionChanged = useCallback((e) => {
    const selectedIndex = e.component.option("selectedIndex");
    let mode: string = EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER;
    if (isModeEACaseUpload) {
      if (selectedIndex === 1) mode = EDIT_OR_ATTACH_COMPONENT_MODES.DOCUMENT_LIBRARY;
      else if (selectedIndex === 2) mode = EDIT_OR_ATTACH_COMPONENT_MODES.EHR;
    } else if (isModeTaskUpload || isModeEAAuditUpload) {
      if (selectedIndex === 1) mode = EDIT_OR_ATTACH_COMPONENT_MODES.DOCUMENT_LIBRARY;
    } else {
      if (selectedIndex === 1) mode = EDIT_OR_ATTACH_COMPONENT_MODES.EHR;
    }
    dispatch({
      type: SET_ATTACH_DOCUMENT_COMPONENT_MODE,
      data: { attachDocumentComponentCurrentMode: mode },
    });
  }, [isModeEACaseUpload, isModeTaskUpload, isModeEAAuditUpload]);

  return (
    <>
      <MdaePopup
        deferRendering={false}
        height={
          isModeTaskUpload ||
          isPopupModeUploadToOCR ||
          documentPopupMode === DOCUMENT_POPUP_MODE.UPLOAD
            ? "78vh"
            : 320
        }
        width={isModeTaskUpload || isPopupModeUploadToOCR ? 950 : 950}//todo
        mdaeTitleRender={getSamplePopupTitle}
        mdaeDataUpdaterConfig={documentManagementPopupUpdaterConfig}
        onShown={() => {
          const el = document.getElementById("btnFileUploader_" + attachDocumentComponentCurrentMode);
          if (el) {
            const uploader = dxFileUploader.getInstance(el) as dxFileUploader;
            if (uploader) uploader.repaint();
          }
        }}
        mdaeContentRender={() => {
          return (
            <div className="mdae-document-uploader-popup-content">
              <MdaePopupContent>
                {(isModeTaskUpload || isPopupModeUploadToOCR) && !hasExtrnlUserTaskEditFg ? (
                  <>
                    <MdaeTabPanel onSelectionChanged={onTabPanelSelectionChanged}>
                      <Item title={"My Computer"}>
                        <div
                          className={
                            disableMyComputerSelection ? "disable-ui" : ""
                          }
                        >
                          <EditOrAttachDocument {...props} uniqueId={effectiveBaseId} mode={EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER} />
                        </div>
                      </Item>
                      <Item title={"Document Library"} visible={isModeTaskUpload && (props.parentAttachmentLevelName === "EA" || props.parentAttachmentLevelName === "EAC")}>
                        <DocumentLibraryGrid
                          documentList={libraryDocumentList}
                          onSelectionChanged={onLibrarySelectionChanged}
                          showLevelSelector={false}
                          showCategorySelector={true}
                          height={400}
                        />
                      </Item>
                      <Item title={"Document Management"}>
                        <div
                          className={disableGridSelection ? "disable-ui" : ""}
                        >
                          <DocumentManagement
                            hasAuditViewAccess={true}
                            isManagerView={false}
                            doNotLoadDatasourcesInd={true}
                            showForCoderReviewInd={false}
                            isBulkDwonloadVisible={false}
                            attachedLevelId={props.parentAttachmentLevelId}
                            attachedLevelName={
                              props.parentAttachmentLevelName
                            }
                            doNotLoadEditDocumentPopup={true}
                            isIncludeNonAuditLevelDocumentCheckBoxVisible={
                              true
                            }
                            isFromCaseDetails={true}
                            isViewOnlyGrid={true}
                            userActionMode={
                              isPopupModeUploadToOCR
                                ? USER_ACTION_MODE.SMART_SCAN_SINGLE_SELECTION
                                : USER_ACTION_MODE.MULTIPLE_SELECTION
                            }
                            setSelectedRowData={setSelectedRowsData}
                            selectedRowsData={selectedRowsData}
                            height={"350"}
                          />
                        </div>
                      </Item>
                    </MdaeTabPanel>
                  </>
                ) : isModeEACaseUpload && !hasExtrnlUserTaskEditFg ? (
                  <MdaeTabPanel
                    onSelectionChanged={onTabPanelSelectionChanged}
                  >
                    <Item title={"My Computer"}>
                      <EditOrAttachDocument
                        {...props}
                        uniqueId={effectiveBaseId}
                        mode={EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER}
                        showLevelSelector={props.hideEhrTab}
                        onDocumentUploaded={(doc) => {
                          const MAX_DOCS = 20;
                          if (totalTemplateDocumentCount >= MAX_DOCS) {
                            mdaeNotify({
                              message: `A process template can have a maximum of ${MAX_DOCS} documents. This template already has ${totalTemplateDocumentCount}.`,
                              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                            });
                            return;
                          }
                          const bytes = doc.fileSize ?? 0;
                          const fileSizeDisplayName = bytes >= 1048576
                            ? `${(bytes / 1048576).toFixed(1)} MB`
                            : `${Math.ceil(bytes / 1024)} KB`;
                          dispatch({
                            type: ADD_ROUND_DOCUMENTS,
                            data: {
                              eaProcessTemplateRoundId: attachedLevelId,
                              pendingDocument: {
                                eaProcessTemplateRoundDocumentAssociationId: nextPendingId(),
                                documentId: doc.documentId,
                                documentName: doc.documentName,
                                originalFileName: doc.originalFileName,
                                fileType: doc.originalFileName?.split('.').pop() ?? '',
                                fileSize: doc.fileSize,
                                fileSizeDisplayName,
                                documentCategoryId: doc.documentCategoryId,
                                documentCategoryName: doc.documentCategoryName,
                                attachedLevelName: doc.attachedLevelName,
                                attachedLevelDisplayName: PAYER_AUDIT_LEVEL_OPTIONS.find((l) => l.code === doc.attachedLevelName)?.displayName ?? '',
                                s3ObjectName: doc.s3ObjectName,
                                createdBy: currentUser?.userName ?? '',
                                createDate: new Date().toISOString(),
                              },
                            },
                          });
                        }}
                      />
                    </Item>
                    <Item title={"Document Library"}>
                      <DocumentLibraryGrid
                        documentList={libraryDocumentList}
                        onSelectionChanged={onLibrarySelectionChanged}
                        showLevelSelector={props.hideEhrTab}
                        showCategorySelector={true}
                        height={400}
                      />
                    </Item>
                    <Item title={"EHR Documentation"} visible={isEhrInboundAPIEnabled && !props.hideEhrTab}>
                      <EhrDocumentsComponent {...props} uniqueId={effectiveBaseId} />
                    </Item>
                  </MdaeTabPanel>
                ) : isModeEAAuditUpload && !hasExtrnlUserTaskEditFg ? (
                  <MdaeTabPanel onSelectionChanged={onTabPanelSelectionChanged}>
                    <Item title={"My Computer"}>
                      <EditOrAttachDocument
                        {...props}
                        uniqueId={effectiveBaseId}
                        mode={EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER}
                      />
                    </Item>
                    <Item title={"Document Library"}>
                      <DocumentLibraryGrid
                        documentList={libraryDocumentList}
                        onSelectionChanged={onLibrarySelectionChanged}
                        showLevelSelector={false}
                        showCategorySelector={true}
                        height={400}
                      />
                    </Item>
                  </MdaeTabPanel>
                ) : (
                  <EditOrAttachDocument
                    {...props}
                    uniqueId={effectiveBaseId}
                    mode={EDIT_OR_ATTACH_COMPONENT_MODES.MY_COMPUTER}
                  />
                )}
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlEditDocumentSecondaryBtn"}
                  role={"secondary"}
                  disabled={!isDocumentPopupSafeToClose}
                  validationGroup="documentValidationGroup"
                  onClick={(e) => {
                    e.validationGroup?.reset();
                    toggleEditDocumentPopupVisible(dispatch, false, dataSourceStoreId);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  disabled={!isDocumentPopupSafeToClose}
                  id={"pnlEditDocumentPrimaryBtn"}
                  role={"primary"}
                  onClick={onDocumentPopupSaveButtonClick}
                  validationGroup="documentValidationGroup"
                >
                  {getSubmitButtonText(
                    isPopupModeUploadToOCR,
                    selctedAttachItemCount,
                    isModeTaskUpload,
                    attachDocumentComponentCurrentMode,
                    documentDataToSave
                  )}
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
      <WaitTimeMessageModal />
    </>
  );
};

const getSubmitButtonText = (
  isPopupModeUploadToOCR,
  selctedAttachItemCount,
  isModeTaskUpload,
  attachDocumentComponentCurrentMode,
  documentDataToSave
) => {
  if (
    attachDocumentComponentCurrentMode ===
      EDIT_OR_ATTACH_COMPONENT_MODES.EHR &&
    documentDataToSave?.length == 0
  )
    return "Import";
  if (isPopupModeUploadToOCR) return "Scan";
  if (isModeTaskUpload && selctedAttachItemCount > 0)
    return "Attach " + selctedAttachItemCount + " Document(s)";
  else if (isModeTaskUpload) return "Attach";
  else return "Save";
};

export default EditDocumentPopup;
